"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var React = _interopRequireWildcard(require("react"));

var _icon = _interopRequireDefault(require("../icon"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var SvgStar = function SvgStar(props, svgRef) {
  var newProps = _objectSpread(_objectSpread({}, props), {}, {
    name: 'SvgStar'
  });

  return /*#__PURE__*/React.createElement(_icon["default"], _objectSpread(_objectSpread({}, newProps), {}, {
    component: function component() {
      return /*#__PURE__*/React.createElement("svg", {
        width: "1em",
        height: "1em",
        viewBox: "0 0 1000 1000",
        fill: "currentColor",
        focusable: false,
        "aria-hidden": "true",
        ref: svgRef
      }, /*#__PURE__*/React.createElement("path", {
        d: "M726.275 620.749L911 413.697l-270.963-58.765L500.5 115 360.963 354.932 90 413.697 274.725 620.75 246.797 897 500.5 785.032 754.203 897l-27.928-276.251zm-226.278 231.33L222.446 974.377c-15.57 6.86-33.754-.2-40.616-15.768a30.803 30.803 0 01-2.459-15.526l30.553-301.736L7.835 415.193c-11.337-12.686-10.242-32.16 2.446-43.497a30.809 30.809 0 0114.007-7.136l296.434-64.186L473.375 38.306c8.564-14.701 27.425-19.678 42.128-11.115a30.807 30.807 0 0111.116 11.115l152.653 262.068 296.434 64.186c16.63 3.6 27.19 20 23.59 36.628a30.805 30.805 0 01-7.137 14.005l-202.09 226.154 30.554 301.736c1.714 16.927-10.62 32.039-27.548 33.753a30.81 30.81 0 01-15.527-2.46L499.997 852.08z",
        fillRule: "nonzero"
      }));
    }
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
var _default = ForwardRef;
exports["default"] = _default;